export const LorenAutomationPlanResolverConstant = {
    PLAN: 'plan',
    PLANS: 'plans'
};
